import type { Text } from '@kkf/design'
import { appUrl } from '@kkf/design'
import type { MessageKey } from '../i18n'
import { LINKS } from './links'
import { LOGO } from './shell'

/**
 * Content for the garage's 404.
 *
 * The verse is 1 Peter 2:25 in the **World English Bible**, which is public domain —
 * quoting ESV or NIV at length carries licensing terms this site would have to honour.
 * Keep the attribution if the translation is swapped.
 *
 * The title, the lead and the verse are editorial and are written in both languages; the
 * links name the same places the nav and the footer do, so they are the same keys.
 *
 * > **The Mongolian verse renders the sense of 1 Peter 2:25 and is not a named
 * > translation.** Which Mongolian Bible the Foundation quotes is its decision.
 */
export const NOT_FOUND = {
  logo: LOGO,
  name: 'King of Kings Garage',
  code: '404',
  title: {
    en: 'This Page Has Wandered Off',
    mn: 'Энэ Хуудас Төөрчихжээ',
  } satisfies Text,
  descr: {
    en: 'The page you were looking for is not here. It may have moved, or the link that brought you may be wrong. Either way, you are not far from where you meant to be.',
    mn: 'Таны хайж байсан хуудас энд алга. Зөөгдсөн байж болох, эсвэл таныг авчирсан холбоос буруу байж магадгүй. Ямартай ч та очих гэсэн газраасаа хол биш байна.',
  } satisfies Text,
  verse: {
    text: {
      en: 'For you were going astray like sheep; but now have returned to the Shepherd and Overseer of your souls.',
      mn: 'Учир нь та нар хонь мэт төөрч явсан боловч эдүгээ сэтгэлийнхээ Хоньчин, Харгалзагч уруу эргэн ирлээ.',
    } satisfies Text,
    reference: { en: '1 Peter 2:25', mn: '1 Петр 2:25' } satisfies Text,
    translation: 'WEB',
  },
  primaryCta: { labelKey: 'notFound.primaryCta' as MessageKey, to: '/' },
  secondaryCta: { labelKey: 'notFound.secondaryCta' as MessageKey, to: '/contact' },
  linksLabelKey: 'footer.wayfinding' as MessageKey,
  links: [
    { labelKey: 'nav.services' as MessageKey, to: '/services' },
    { labelKey: 'nav.programmes' as MessageKey, to: '/programmes' },
    { labelKey: 'nav.foundation' as MessageKey, href: LINKS.foundation },
    { labelKey: 'nav.resort' as MessageKey, href: LINKS.resort },
    { labelKey: 'nav.partners' as MessageKey, href: LINKS.partners },
    { labelKey: 'nav.donate' as MessageKey, href: appUrl(LINKS, 'foundation', '/donations') },
  ],
}
